module.exports = __webpack_public_path__ + "static/media/Communicate_TEAL.3e6d569e.png";